import React from "react";

const NotFound = () => {
  return <>404 not found</>;
};

export default NotFound;
